import { useState } from "react";
import { useToast } from "@/hooks/use-toast";
import { authService } from "@/services/authService";
import { useAuthState } from "@/hooks/useAuthState";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Key } from "lucide-react";
import { MinhaAreaPageShell } from "@/components/MinhaAreaPageShell";

const ChangePassword = () => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { toast } = useToast();
  const { userId, user, userType, isAuthenticated } = useAuthState();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!userId) {
      toast({
        title: "Erro",
        description: "Usuário não encontrado",
        variant: "destructive",
      });
      return;
    }

    if (newPassword !== confirmPassword) {
      toast({
        title: "Erro",
        description: "As senhas não coincidem",
        variant: "destructive",
      });
      return;
    }

    if (newPassword.length < 6) {
      toast({
        title: "Erro",
        description: "A senha deve ter pelo menos 6 caracteres",
        variant: "destructive",
      });
      return;
    }

    setLoading(true);
    try {
      const success = await authService.changePassword(userId, currentPassword, newPassword);
      
      if (success) {
        toast({
          title: "Senha alterada",
          description: "Sua senha foi alterada com sucesso!",
        });
        setCurrentPassword("");
        setNewPassword("");
        setConfirmPassword("");
      } else {
        throw new Error("Senha atual incorreta ou erro ao alterar senha");
      }
    } catch (error: any) {
      toast({
        title: "Erro ao alterar senha",
        description: error.message,
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <MinhaAreaPageShell>
<div>
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-foreground mb-2">Alterar Senha</h1>
        <p className="text-muted-foreground">Mantenha sua conta segura atualizando sua senha regularmente</p>
    </div>

      <Card className="max-w-2xl shadow-md">
        <CardHeader className="bg-muted/30">
          <CardTitle className="flex items-center gap-3 text-foreground">
            <div className="p-2 bg-primary/10 rounded-lg">
              <Key className="h-5 w-5 text-primary" />
    </div>
            Redefinir Senha
          </CardTitle>
        </CardHeader>
        <CardContent className="pt-6">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-3">
              <Label htmlFor="currentPassword" className="text-sm font-medium text-foreground">Senha Atual</Label>
              <Input
                id="currentPassword"
                type="password"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                placeholder="Digite sua senha atual"
                required
                className="h-11"
              />
    </div>
            <div className="space-y-3">
              <Label htmlFor="newPassword" className="text-sm font-medium text-foreground">Nova Senha</Label>
              <Input
                id="newPassword"
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="Digite a nova senha"
                required
                minLength={6}
                className="h-11"
              />
              <p className="text-xs text-muted-foreground">Mínimo de 6 caracteres</p>
    </div>
            <div className="space-y-3">
              <Label htmlFor="confirmPassword" className="text-sm font-medium text-foreground">Confirmar Senha</Label>
              <Input
                id="confirmPassword"
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Confirme a nova senha"
                required
                minLength={6}
                className="h-11"
              />
    </div>
            <Button type="submit" disabled={loading} className="w-full h-11">
              {loading ? "Alterando..." : "Alterar Senha"}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
    </MinhaAreaPageShell>
  );
};

export default ChangePassword;
